import styled from '@mui/material/styles/styled';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';

export const StyledListItemButton = styled(ListItemButton)({
  width: '100%',
  flexDirection: 'column',
  alignItems: 'flex-start',
  overflow: 'hidden',
});
export const ItemTitle = styled((props) => (
  <Typography variant='subtitle1' noWrap  {...props} />
))({
  width: '100%',
  fontWeight: 600,
});
export const ItemSubtitle = styled((props) => (
  <Typography variant='caption' color='textSecondary' noWrap  {...props} />
))({
  width: '100%',
});